import * as React from 'react';
import { SendHorizonalIcon } from 'lucide-react';

import { routes } from '@workspace/routes';
import { LinkedInIcon, XIcon } from '@workspace/ui/components/brand-icons';

export const MENU_LINKS = [
  {
    title: 'Upload',
    href: routes.marketing.Index + '#upload',
    external: false
  },
  {
    title: 'Contact',
    description: 'Reach out for assistance',
    icon: <SendHorizonalIcon className="size-5 shrink-0" />,
    href: routes.marketing.Contact,
    external: false
  }
];

export const FOOTER_LINKS = [
  {
    title: 'Resources',
    links: [
      { name: 'Contact', href: routes.marketing.Contact, external: false }
    ]
  },
  {
    title: 'About the author',
    links: [{ name: 'Blog', href: 'https://katsuba.dev', external: true }]
  },
  {
    title: 'Legal',
    links: [
      {
        name: 'Terms of Use',
        href: routes.marketing.TermsOfUse,
        external: false
      },
      {
        name: 'Privacy Policy',
        href: routes.marketing.PrivacyPolicy,
        external: false
      },
      {
        name: 'Cookie Policy',
        href: routes.marketing.CookiePolicy,
        external: false
      }
    ]
  }
];

export const SOCIAL_LINKS = [
  {
    name: 'X (formerly Twitter)',
    href: 'https://x.com/katsuba_dev',
    icon: <XIcon className="size-4 shrink-0" />
  },
  {
    name: 'LinkedIn',
    href: 'https://www.linkedin.com/in/ikatsuba/',
    icon: <LinkedInIcon className="size-4 shrink-0" />
  }
];
